// extracted by css-extract-rspack-plugin
export default {"page":"page-idq7pZ"};